/**
 * A padel ball with the flag of Madeira inside it.
 *
 * Flag detail that is easy to get wrong: the Cross of the Order of Christ is a
 * flared red cross patty with a *straight-armed* white Greek cross inset, and
 * the whole cross sits inside the gold band rather than spilling onto the blue.
 * The ball's seams are pulled toward the edges so they stay on the blue and
 * leave the cross readable.
 */
export function BallLogo({ size = 30 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label="Padel Madeira"
    >
      <defs>
        <clipPath id="ball-clip">
          <circle cx="16" cy="16" r="14" />
        </clipPath>
      </defs>

      <g clipPath="url(#ball-clip)">
        <rect width="32" height="32" fill="#2E4A84" />
        <rect x="9.5" width="13" height="32" fill="#FFCE00" />

        {/* Red cross patty: narrow where the arms meet, flaring to flat tips. */}
        <path
          d="M14.25 14.25 L12.7 10 L19.3 10 L17.75 14.25 L22 12.7 L22 19.3 L17.75 17.75 L19.3 22 L12.7 22 L14.25 17.75 L10 19.3 L10 12.7 Z"
          fill="#C8102E"
        />
        {/* White Greek cross inset: uniform arm width, squared ends. */}
        <rect x="14.95" y="11.4" width="2.1" height="9.2" fill="#FFFFFF" />
        <rect x="11.4" y="14.95" width="9.2" height="2.1" fill="#FFFFFF" />

        <path d="M6.1 6.1 Q10 16 6.1 25.9" stroke="#FFFFFF" strokeWidth="1.6" fill="none" />
        <path d="M25.9 6.1 Q22 16 25.9 25.9" stroke="#FFFFFF" strokeWidth="1.6" fill="none" />
      </g>

      <circle cx="16" cy="16" r="14" fill="none" stroke="#FFFFFF" strokeWidth="1.4" opacity="0.85" />
      <circle cx="16" cy="16" r="14.7" fill="none" stroke="#2E4A84" strokeWidth="0.8" opacity="0.3" />
    </svg>
  )
}
